import styled, { css } from 'styled-components';
import { ListItem } from '@cko/primitives';
import { NavLink } from 'react-router-dom';
import {
  levelOneContentStyle,
  levelOnePaddingStyle,
  menuItemHoverStyle,
} from '../../SideNavMenu.styles';

export const StyledSideNavLevelOneListItem = styled(ListItem)`
  ${levelOnePaddingStyle}
  ${menuItemHoverStyle}
`;

export const StyledSideNavLevelOneNavLink = styled(NavLink)<{
  $isActiveRoute?: boolean;
}>`
  ${levelOneContentStyle}
  text-decoration: none;

  ${({ $isActiveRoute }) => $isActiveRoute && activeLevelOneLinkStyle}
`;

export const StyledBlockedLevelOneLink = styled.div`
  ${levelOneContentStyle}
  color: var(--control-text-disabled);
`;

const activeLevelOneLinkStyle = css`
  color: var(--action-text-visited);
`;
